import React from "react";
//#region types
import { DialogEnums, StyleEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants, SalaryConstants } from "utils/constants";
//#endregion
//#region components
import GrossSalaryChangeFormContainer from "./forms/grossSalaryChangeFormContainer";
import GrossSalaryChangePreview from "./_partials/grossSalaryChangePreview";
import ZeroGrossSalaryChangeContent from "./_partials/zeroGrossSalaryChangeContent";
import { GrossSalaryChangeProvider } from "./context/grossSalaryChangeContext";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useGrossSalaryChangeDialog() {
  const getTargetGrossSalaryChangeDialog = (
    personId: number,
    yearMonth: number,
    personName: string,
    onGrossSalaryChangeSuccess?: () => void
  ): DialogProps => {
    return {
      id: SalaryConstants.GrossSalaryChangeDialogId,
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.GrossSalaryChangeFormTitle),
      titleIcon: IconDefinitionConstants.WEdit,
      dialogType: DialogEnums.DialogType.Content,
      children: <GrossSalaryChangeFormContainer personId={personId} yearMonth={yearMonth} personName={personName} />,
      maxWidth: "sm",
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Save),
          successMessage: TranslationKeys.Salary.GrossSalaryChangeSuccess,
        },
      ],
      previewElement: <GrossSalaryChangePreview />,
      contextProvider: GrossSalaryChangeProvider,
      contextProviderProps: { personId, yearMonth },
      onSubmit: onGrossSalaryChangeSuccess,
    };
  };

  const getZeroGrossSalaryChangeDialog = (
    personId: number,
    yearMonth: number,
    personName: string,
    onConfirm?: () => Promise<any>,
    onGrossSalaryChangeSuccess?: () => void
  ): DialogProps => {
    return {
      id: SalaryConstants.ZeroGrossSalaryChangeDialogId,
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.ZeroGrossSalaryChangeDialogTitle),
      titleIcon: IconDefinitionConstants.WInfo,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Salary.ZeroGrossSalaryChangeDialogResetSalary
          ),
          onClick: onConfirm,
          successMessage: TranslationKeys.Salary.ZeroGrossSalaryChangeDialogSuccessMessage,
          type: StyleEnums.DisplayType.Danger,
          disableWhenInvalid: true,
        },
      ],
      dialogType: DialogEnums.DialogType.Content,
      hideDivider: true,
      children: (
        <ZeroGrossSalaryChangeContent>
          {LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Salary.ZeroGrossSalaryChangeDialogDescription,
            "",
            { personName }
          )}
        </ZeroGrossSalaryChangeContent>
      ),
      type: StyleEnums.DisplayType.Danger,
      previewElement: <GrossSalaryChangePreview />,
      contextProvider: GrossSalaryChangeProvider,
      contextProviderProps: { personId, yearMonth, zeroGrossSalaryChange: true },
      onSubmit: onGrossSalaryChangeSuccess,
    };
  };

  return { getTargetGrossSalaryChangeDialog, getZeroGrossSalaryChangeDialog };
}

export default useGrossSalaryChangeDialog;
